import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWater, faUpLong, faDownLong } from '@fortawesome/free-solid-svg-icons';

import { FormattedValue } from './FormattedValue';

interface RiverLevelStatsProps {
    level: number;
    levelChange: number | null;
    isLoaded: boolean;
}

const RiverLevelStats: React.FC<RiverLevelStatsProps> = ({ level, levelChange, isLoaded }) => {
    let levelDiff;
    if (levelChange !== null) {
        const levelIcon = levelChange > 0 ? <FontAwesomeIcon color='red' icon={faUpLong}></FontAwesomeIcon> : <FontAwesomeIcon color='green' icon={faDownLong}></FontAwesomeIcon>;
        levelDiff = <div className="level-diff">{levelIcon}<span>{levelChange.toFixed(2)} m</span></div>
    } else {
        levelDiff = <span />
    }
    return <div className="column is-one-third metric rain-container">
                <div className="is-flex is-flex-direction-column">
                    <FontAwesomeIcon color='lightBlue' size='2x' icon={faWater} />
                    <FormattedValue isLoaded={isLoaded} value={level} unit='m'></FormattedValue>
                    {levelDiff}
                </div>
            </div>
}

export default RiverLevelStats;
